// extracted by mini-css-extract-plugin
module.exports = {"title":"PackagePayment_title__3ZToj","list-plan":"PackagePayment_list-plan__3kBU9"};